/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");


export function IEVer() {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('msie')) {
    return parseInt(ua.split('msie')[1], 10);
  }
  return 0;
}




// WEBPACK FOOTER //
// ./src/utils/IEUtils.js